export default __webpack_public_path__ + "70276671108159d6458ab49450546df5.jpg";